import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import CreateBackfillForm from "../components/backfill/CreateBackfillForm";
import ConfirmationDialog from "../components/shared/DialogConfirmation";
import PageContainer from "../components/shared/PageContainer";
import { useConfig } from "../contexts/ConfigContext";
import * as Objects from "../services/api";
import { JobOperation, Profile, Profiles, TemplateSetAggregate, TemplateSets } from "../services/api";
import { BackfillSearchOption, OperationType } from "../services/api/JobOperation";

const BackfillCreate: React.FC = () => {
  const { config } = useConfig();
  const navigate = useNavigate();
  const [availableProfiles, setAvailableProfiles] = useState<Profile[]>([]);
  const [availableSets, setAvailableSets] = useState<TemplateSetAggregate[]>([]);
  const [totalJobsFound, setTotalJobsFound] = useState<number>(-1);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [jobOperation, setJobOperation] = React.useState<JobOperation>(
    new JobOperation({
      accounts: config.registerAccounts,
      primary_regions: config.regions.primary_regions,
      secondary_regions: config.regions.secondary_regions,
      backfillSearchOption: BackfillSearchOption.PARAMS,
      overwrite: true,
      useDefaultProfiles: false,
      profiles: [],
      operation: OperationType.TRANSCODE,
      backfill: true,
    }),
  );

  useEffect(() => {
    setJobOperation(
      (prevJobOperation) =>
        new JobOperation({
          ...prevJobOperation,
          accounts: config.registerAccounts,
          primary_regions: config.regions.primary_regions,
          secondary_regions: config.regions.secondary_regions,
        }),
    );
  }, [config.regions, config.registerAccounts]);

  useEffect(() => {
    Profiles.list().then(setAvailableProfiles);
    TemplateSets.list().then(setAvailableSets);
  }, []);

  const handleSearchClick = () => {
    Objects.Jobs.list(jobOperation.getSearchQueryParams()).then((result) => {
      setTotalJobsFound(result.count);
      setConfirmationModalOpen(true);
    });
  };

  const handleRunBackfillClick = () => {
    jobOperation.create().then(() => navigate("/backfill"));
  };

  return (
    <PageContainer>
      <CreateBackfillForm
        availableProfiles={availableProfiles}
        availableSets={availableSets}
        jobOperation={jobOperation}
        setJobOperation={setJobOperation}
        onSearchClick={handleSearchClick}
      ></CreateBackfillForm>
      <ConfirmationDialog
        open={confirmationModalOpen}
        title={"Create Backfill Confirmation"}
        onConfirm={handleRunBackfillClick}
        onClose={() => {
          setConfirmationModalOpen(false);
        }}
        message={`Are you sure you want to run a backfill on an estimated total of ${totalJobsFound} jobs?`}
      />
    </PageContainer>
  );
};

export default BackfillCreate;
